import { useEffect } from 'react';
import { ScholarityLabels } from '@/constants/recommendation';
import { ProfileStepIds, Scholarity } from '@/models/recommendation';
import { RadioQuestion } from '@/packages/profile-quiz/components/questions/radio-question';
import { useProfileQuiz } from '@/packages/profile-quiz/context/profile-quiz';
import type { QuestionProps } from '@/packages/profile-quiz/context/profile-quiz/types';
import { ProfileFields } from '@/packages/profile-quiz/context/profile-quiz/types';

export const ScholarityStep = (_props: QuestionProps) => {
  const { answers, setQuizAnswer, setCurrentStepValid } = useProfileQuiz();

  useEffect(() => {
    setCurrentStepValid(answers.scholarity !== null);
  }, [answers.scholarity, setCurrentStepValid]);

  const handleSelectScholarity = (scholarity: Scholarity) => {
    setQuizAnswer(ProfileFields.Scholarity, scholarity);
    setCurrentStepValid(true);
  };

  return (
    <RadioQuestion
      questionTitle="🎓 Até que nível você concluiu seus estudos?"
      questionId={ProfileStepIds.Scholarity}
      processedResponseText="Perfeito, formação registrada. Isso já dá uma boa noção da sua base acadêmica e de onde podemos partir!"
      handleSelectAnswer={(answer) =>
        handleSelectScholarity(answer as Scholarity)
      }
      options={Object.values(Scholarity).map((scholarity) => ({
        label: ScholarityLabels[scholarity],
        value: scholarity,
      }))}
      currentValue={answers.scholarity}
    />
  );
};
